import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import {apiV2} from "api/firebase";
import SitkaIcon from "view/images/SitkaIcon";
import useStyles from "./styles";

type SSOSitkaProps = {
  showId: string;
  exhibitorPairId: string;
};

function SSOSitka({showId, exhibitorPairId}: SSOSitkaProps) {
  const classes = useStyles({headerBackground: false});

  const handleButtonClick = async () => {
    const {link} = await apiV2.sitka.getSsoLink({
      showId,
      exhibitorPairId,
    });

    if (!link) {
      return;
    }
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <div>
      <Box className={classes.tooltipAppItem}>
        <Box className={classes.tooltipItemLink} onClick={handleButtonClick}>
          <SitkaIcon />
          <Typography>Sitka</Typography>
        </Box>
      </Box>
    </div>
  );
}

export default SSOSitka;
